<template>
  <v-app style="background-color: #ddf7ff">
      <Toolbar />
      <router-view></router-view>
      <Footer/>
    </v-app>
</template>

<script>
import Toolbar from '../layouts/Toolbar.vue'
import Footer from '../layouts/Footer.vue'
export default {
  name: 'portal_layout',
  components: {
    Toolbar,
    Footer
  }
}
</script>
